/**
 * 百度统计数据监测
 */
export default function baiduTjUtils() {
	var _hmt = _hmt || []
	window._hmt = _hmt
	;(function () {
		var hm = document.createElement('script')
		hm.src = 'https://hm.baidu.com/hm.js?172d61c8d841565391f24fadc9896429'
		var s = document.getElementsByTagName('script')[0]
		s.parentNode.insertBefore(hm, s)
	})()
}
